import gql from 'graphql-tag';
import { FeatureExhibitsInteractivesFragment } from '@graphqlTypes';
import { ExhibitFragment } from '@/fragments/Exhibit';
import { SingleExhibitsInteractives } from './SingleExhibitsInteractives';
import { getExhibitData } from './utils';
import { CarouselExhibitsInteractives } from './CarouselExhibitsInteractives';

export default function FeatureExhibitsInteractives(props: FeatureExhibitsInteractivesFragment) {
  const { exhibits, headline } = props;
  const isSingle = exhibits?.length === 1;
  return (
    <>
    { isSingle ? (
      <SingleExhibitsInteractives
        exhibit={getExhibitData(exhibits[0])}
        headline={headline}
      />

    ) : (
      <CarouselExhibitsInteractives {...props} />
    )}
    </>
  )
}

FeatureExhibitsInteractives.fragments = {
  entry: gql`
    ${ExhibitFragment}
    fragment FeatureExhibitsInteractives on FlexiblePageContentContentFeatureExhibitsInteractivesLayout {
      headline
      subhead
      cta {
        label
        linkType
        externalLink
        page {
          node {
            uri
          }
        }
      }
      exhibits {
        type
        labelOverride
        exhibit {
          node {
            ...ExhibitFragment
          }
        }
        manualExhibit {
          headline
          excerpt
          mediaType
          videoUrl
          exhibitType
          link {
            linkType
            externalLink
            sectionId
            page {
              node {
                uri
              }
            }
          }
          image {
            ...ACFMedia
          }
          videoThumbnail {
            ...ACFMedia
          }
        }
      }
    }
  `,
};